import { useEffect, useState } from "react";
import { inboundApi } from "@/lib/api";
import { RefreshCcw, Mail, Paperclip } from "lucide-react";

export default function InboundLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const load = () => { setLoading(true); inboundApi.log().then(setRows).finally(() => setLoading(false)); };
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);

  return (
    <div className="space-y-8">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="font-display text-4xl font-bold text-espresso" data-testid="inbound-title">Inbound email log</h1>
          <p className="text-espresso-ink/60 mt-2 max-w-2xl">Every email hitting the Resend webhook lands here, routed or not. Add a business subject prefix (e.g. <b>[BROS-CT]</b>) to route documents automatically.</p>
        </div>
        <button onClick={load} data-testid="inbound-refresh" className="inline-flex items-center gap-2 px-3 py-2 border border-canvas-border text-sm font-semibold text-espresso hover:bg-canvas-border/50 rounded-lg">
          <RefreshCcw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} /> Refresh
        </button>
      </div>

      <div className="bg-white border border-canvas-border rounded-2xl overflow-hidden shadow-soft">
        {rows.length === 0 ? (
          <div className="p-14 text-center text-espresso-ink/50" data-testid="inbound-empty">
            No emails yet. Send one to your Resend inbound alias with a business subject prefix.
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-canvas text-xs uppercase tracking-wider text-espresso-ink/60">
              <tr>
                <th className="text-left px-5 py-3">Received</th>
                <th className="text-left px-5 py-3">From</th>
                <th className="text-left px-5 py-3">To</th>
                <th className="text-left px-5 py-3">Subject</th>
                <th className="text-left px-5 py-3">Attachments</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-canvas-border align-top" data-testid={`inbound-row-${r.id}`}>
                  <td className="px-5 py-3 whitespace-nowrap text-espresso-ink/70">{new Date(r.received_at).toLocaleString()}</td>
                  <td className="px-5 py-3 font-medium text-espresso">{r.from}</td>
                  <td className="px-5 py-3 text-espresso-ink text-xs">{(r.to || []).join(", ")}</td>
                  <td className="px-5 py-3 text-espresso"><Mail className="w-3 h-3 inline mr-1 text-gold" /> {r.subject || "(no subject)"}</td>
                  <td className="px-5 py-3">
                    {r.num_attachments > 0 ? (
                      <span className="inline-flex items-center gap-1 text-gold font-semibold"><Paperclip className="w-3 h-3" /> {r.num_attachments}</span>
                    ) : <span className="text-espresso-ink/40">—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
